class Fraude {
  constructor(id, user, idn, cpf, safCode, description, conclusion, userAudit, nistFile, status, translateStatus, creationDate, modificationDate, process) {
    this.id = id
    this.user = user
    this.idn = idn
    this.cpf = cpf
    this.safCode = safCode
    this.description = description
    this.conclusion = conclusion
    this.userAudit = userAudit
    this.nistFile = nistFile
    this.status = status
    this.translateStatus = translateStatus
    this.creationDate = creationDate
    this.modificationDate = modificationDate
    this.process = process
  }
  getId() {
    return this.id
  }

  setId(id) {
    this.id = id
  }

  getUser() {
    return this.user
  }

  setUser(user) {
    this.user = user
  }

  getIdn() {
    return this.idn
  }

  setIdn(idn) {
    this.idn = idn
  }

  getCpf() {
    return this.cpf
  }

  setCpf(cpf) {
    this.cpf = cpf
  }

  getSafCode() {
    return this.safCode
  }

  setSafCode(safCode) {
    this.safCode = safCode
  }

  getDescription() {
    return this.description
  }

  setDescription(description) {
    this.description = description
  }

  getConclusion() {
    return this.conclusion
  }

  setConclusion(conclusion) {
    this.conclusion = conclusion
  }

  getUserAudit() {
    return this.userAudit
  }

  setUserAudit(userAudit) {
    this.userAudit = userAudit
  }

  getNistFile() {
    return this.nistFile
  }

  setNistFile(nistFile) {
    this.nistFile = nistFile
  }

  getStatus() {
    return this.status
  }

  setStatus(status) {
    this.status = status
  }

  getTranslateStatus() {
    return this.translateStatus
  }

  setTranslateStatus(translateStatus) {
    this.translateStatus = translateStatus
  }

  getCreationDate() {
    return this.creationDate
  }

  setCreationDate(creationDate) {
    this.creationDate = creationDate
  }

  getModificationDate() {
    return this.modificationDate
  }

  setModificationDate(modificationDate) {
    this.modificationDate = modificationDate
  }

  getProcess() {
    return this.process
  }

  setProcess(process) {
    this.process = process
  }

}
export {
    Fraude as default
}



// WEBPACK FOOTER //
// ./src/model/Fraude.js